import getProfileStore from '../store/profileStore';
import type { AccountSource } from 'owa-graph-schema';

export function getMailboxSources(): AccountSource[] {
    return getProfileStore().accountSources.filter(
        accountSource => accountSource.capabilities.hasServerMailbox || accountSource.mailbox
    );
}
